<template>
    <div style="height: 600px;">
    <div class="dashboard-box stats-box w-full px-2 mb-5" style="height: 100%;">
            <v-card
            class="pa-2"
            tile
            style="height: 100%;"
            >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')" style="height: 100%;">
                <div v-if="isPending" class="flex flex-column items-center justify-center" style="height: 100%; text-align: center;">
                    <h3 style="margin-bottom: 8px;">This Geo Grid scan hasn't been run yet</h3>
                    <p style="color: #757B89; margin-bottom: 16px;">Resume the grid tracker tool to configure and run the scan.</p>
                    <div class="border-1 border-blue text-xs text-bold px-4 py-2 rounded cursor-pointer" style="background: #2477F6; color: #FFFFFF; display: inline-block;" @click="completeReport()">COMPLETE REPORT</div>
                </div>
                <div v-else class="flex flex-row flex-wrap" style="height: 100%;">
                    <object :data="search.properties.report_pdf" type="application/pdf" width="100%" height="100%">
                        <p>It appears you don't have a PDF plugin for this browser.
                        No biggie... you can <a href="myfile.pdf">click here to
                        download the PDF file.</a></p>
                    </object>
                </div>
            </div>
            </v-card>
        </div>
    </div>
  </template>


  <script>
  import axios from 'axios'
  import moment from 'moment'
  import $ from 'jquery'
  import ApexCharts from 'apexcharts'
  import VueGauge from "@/views/local-recon/VueGauge";

  export default {
    props: ['search', 'widget'],
    data () {
        return {
            faq_keywords: "",
            reviews_html: "",
            negative_reviews_html: "",

            sentiment_data: [],
        }
    },
    computed: {
        isPending() {
            return !this.search.properties || !this.search.properties.report_pdf;
        }
    },
    methods: {
        completeReport() {
            let gridTrackerBusinessObject = {
                name: (this.search.properties && this.search.properties.business_name) || this.search.keyword,
                place_id: this.search.place_id
            };

            let userUuid = this.search.user ? this.search.user.uuid : '';

            window.open(window.location.origin + "/grid-tracker/app?w=" + this.widget.uuid + '&u=' + userUuid + '&g=' + btoa(JSON.stringify(gridTrackerBusinessObject)) + '&q=' + (this.search.keyword || '') + '&si=' + this.search.id);
        }
    },
    created() {

    }
  }
  </script>